export default __webpack_public_path__ + "static/media/health_check_female_3x2_En.bdd16218.webp";